import {createContext} from "react";
import {useMutation} from "@apollo/react-hooks";
import {UpdateVeriflytAccountMutation} from "./graphql";
import {useEventTrigger} from "context/event-context";

export interface VeriflytRegistererContextInterface {
    entityID?: string;
    accountRegistrar?: {
        registerAuto: () => Promise<string>;
        registerManual: (veriflytID: string) => Promise<string>;
        isRegistering: boolean;
        isValid: boolean;
    }
}

export function useVeriflytRegistererContext(entityID: string): VeriflytRegistererContextInterface {

    const [ invoke, { loading } ] = useMutation(UpdateVeriflytAccountMutation);

    const eventTrigger = useEventTrigger();

    function broadcastRegisterComplete(veriflytID: string) {
        eventTrigger('veriflyt.entityRegisteredToVeriflyt', { entityID: entityID, veriflytID: veriflytID });
    }

    return {
        accountRegistrar: {
            registerAuto: async () => {
                const result = await invoke({ variables: { entityID: entityID } });
                broadcastRegisterComplete(result.data?.veriflytID);
                return result.data?.veriflytID;
            },
            registerManual: async (veriflytID: string) => {
                const result = await invoke({ variables: { entityID: entityID, veriflytID: veriflytID } });
                broadcastRegisterComplete(result.data?.veriflytID);
                return result.data?.veriflytID;
            },
            isRegistering: loading,
            isValid: !!entityID
        }
    };
}

export const VeriflytRegistererContext = createContext<VeriflytRegistererContextInterface>(null);

